import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { routerPaths } from '@epi-constants/routerPaths';
import { BenefitGroupsList } from '@epi-pages/BenefitGroups/BenefitGroupsList';
import { CreateBenefitGroup } from '@epi-pages/BenefitGroups/CreateBenefitGroup';
import { EditBenefitGroup } from '@epi-pages/BenefitGroups/EditBenefitGroup';
import { NotFound } from '@epi-containers/NotFound/NotFound';
import { getApplicationLanguageId } from '@epi-store/application/application.selectors';

export const BenefitGroups = () => {
  const langPrefix = useSelector(getApplicationLanguageId);
  const fixedLangPrefix = langPrefix === 'fi' ? '' : `/${langPrefix}`;

  return (
    <Switch>
      <Route exact path={`${fixedLangPrefix}${routerPaths.benefitGroups}`}>
        <BenefitGroupsList />
      </Route>
      <Route path={`${fixedLangPrefix}${routerPaths.createBenefitGroup}`}>
        <CreateBenefitGroup />
      </Route>
      <Route path={`${fixedLangPrefix}${routerPaths.editBenefitGroup}`}>
        <EditBenefitGroup />
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
};
